const STORAGE_KEY = 'sisfol_servidor_post_auth_return_to';

const ALLOWED_PATH_PREFIXES = [
  '/dashboard',
  '/recadastramento',
  '/contracheques/',
  '/requerimentos',
  '/notificacoes',
  '/avisos',
  '/ajuda',
  '/ficha-funcional',
];

const BLOCKED_AUTH_PATHS = new Set([
  '/login',
  '/change-password',
  '/selecionar-vinculo',
  '/instalar',
]);

export const sanitizePostAuthPath = (value, fallback = '/dashboard') => {
  const raw = String(value || '').trim();
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return fallback;

  try {
    const baseOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://sisdp.invalid';
    const parsed = new URL(raw, baseOrigin);
    if (parsed.origin !== baseOrigin || BLOCKED_AUTH_PATHS.has(parsed.pathname)) return fallback;

    const allowed = ALLOWED_PATH_PREFIXES.some((prefix) => (
      prefix.endsWith('/') ? parsed.pathname.startsWith(prefix) : parsed.pathname === prefix
    ));
    if (!allowed) return fallback;

    parsed.searchParams.delete('sisfol_chunk_retry');
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (error) {
    return fallback;
  }
};

export const buildCurrentReturnPath = (location) => sanitizePostAuthPath(
  `${location?.pathname || '/dashboard'}${location?.search || ''}${location?.hash || ''}`,
  '/dashboard'
);

export const persistPostAuthPath = (value) => {
  const safePath = sanitizePostAuthPath(value, '');
  if (!safePath) return '';
  try {
    sessionStorage.setItem(STORAGE_KEY, safePath);
  } catch (error) {
    // Sem sessionStorage, o parâmetro returnTo do login ainda cobre o primeiro redirecionamento.
  }
  return safePath;
};

export const peekPostAuthPath = (fallback = '/dashboard') => {
  try {
    return sanitizePostAuthPath(sessionStorage.getItem(STORAGE_KEY), fallback);
  } catch (error) {
    return fallback;
  }
};

export const consumePostAuthPath = (fallback = '/dashboard') => {
  const target = peekPostAuthPath(fallback);
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Sem efeito funcional.
  }
  return target;
};

export const clearPostAuthPath = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Sem efeito funcional.
  }
};
